// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { displayGiftCard, GiftCardPaymentOptionPropTypes } from 'utils';

import Checkbox from '../Checkbox';

const GCPaymentOption = ({ classes, children, variant, card, isChecked, isDefault, onChange, ...inputProps }) => {
  switch (variant) {
    case 'checkbox':
      return (
        <>
          <Checkbox
            data-testid="checkbox"
            classes={{ label: classes.label }}
            label={displayGiftCard(card)}
            checked={isChecked}
            onChange={onChange}
            {...inputProps}
          />
          {children}
        </>
      );
    default:
      return null;
  }
};

GCPaymentOption.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node,
  variant: PropTypes.oneOf(['checkbox']),
  card: GiftCardPaymentOptionPropTypes,
  isChecked: PropTypes.bool,
  isDefault: PropTypes.bool,
  onChange: PropTypes.func,
};

GCPaymentOption.defaultProps = {
  classes: {},
  variant: 'checkbox',
  card: {},
  isChecked: false,
  isDefault: false,
  onChange: () => null,
};

export default GCPaymentOption;
